import React, { useState } from 'react';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import MuiToolbar from "@mui/material/Toolbar";
import moment from "moment";
import { useHistory } from '../../utils/reactRouterCompatibility';
import { useTranslation } from "react-i18next";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DeleteDialog from "./DeleteDialog";
import { useSelector } from 'react-redux';
import { getSupportBoxRoute } from "../../../router/routes/support/factory/boxes";
import SearchIcon from '@mui/icons-material/Search';
import { Link } from "react-router-dom";
import { getSiteUserEditRoute } from "../../../router/routes/site/factory/user";
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from "@mui/material/useMediaQuery";

const StyledToolbar = styled(MuiToolbar)(({ theme }) => ({
    padding: theme.spacing(1, 0),
    gap: theme.spacing(2),
}));

const UserInfo = styled(Box)(({ theme }) => ({
    flex: 1,
    minWidth: 0,
}));

const Toolbar = ({ ticket, onClosed, box }) => {
    const history = useHistory();
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const hasRight = useSelector(state => state.access.manager);

    const [anchorMenuEl, setAnchorMenuEl] = useState(null);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const handleClickMenu = event => {
        setAnchorMenuEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorMenuEl(null);
    };

    const handleBackClick = () => {
        history.push(getSupportBoxRoute(box || 'inbox'));
    };

    const onTicketClosed = d => {
        setShowDeleteDialog(false);
        onClosed(d);
    };

    return (
        <>
            <Typography variant="h6" component="h2" gutterBottom sx={{ fontWeight: 500 }}>
                {ticket.Subject}
            </Typography>

            <StyledToolbar disableGutters>
                {!isMobile && (
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="back"
                        onClick={handleBackClick}
                        size="small"
                    >
                        <ArrowBackIosIcon fontSize="small" />
                    </IconButton>
                )}

                <Avatar
                    sx={{ width: 40, height: 40 }}
                    src={ticket.User.Profile.Media_Image?.Url || ''}
                />

                <UserInfo>
                    <Typography variant="body2" color="text.secondary">
                        {moment(parseInt(ticket.Last_Update.unixms)).format('LLL')}
                    </Typography>
                    <Typography variant="subtitle2">
                        {ticket.User.Profile.Display_Name || t('support_ticket_anonymous')}
                    </Typography>
                    {ticket.User.Email && (
                        <Typography variant="body2" color="text.secondary" noWrap>
                            {ticket.User.Email}
                        </Typography>
                    )}
                </UserInfo>

                <IconButton
                    aria-label="view user"
                    component={Link}
                    target="_blank"
                    to={getSiteUserEditRoute(ticket.User.User__)}
                    size="small"
                >
                    <SearchIcon />
                </IconButton>

                {hasRight && ticket.Status !== 'closed' && (
                    <>
                        <IconButton
                            aria-label="more options"
                            onClick={handleClickMenu}
                            size="small"
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            anchorEl={anchorMenuEl}
                            open={Boolean(anchorMenuEl)}
                            onClose={handleCloseMenu}
                        >
                            <MenuItem onClick={() => {
                                handleCloseMenu();
                                setShowDeleteDialog(true);
                            }}>
                                <ListItemIcon>
                                    <HighlightOffIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={t('close_ticket_btn')} />
                            </MenuItem>
                        </Menu>
                    </>
                )}
            </StyledToolbar>

            <DeleteDialog
                open={showDeleteDialog}
                setOpen={setShowDeleteDialog}
                onTicketClosed={onTicketClosed}
                ticket={ticket}
            />
        </>
    );
};

export default Toolbar;
